import { render, staticRenderFns } from "./secondClaimHN.vue?vue&type=template&id=013823aa"
import script from "./secondClaimHN.vue?vue&type=script&lang=js"
export * from "./secondClaimHN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports